import { OutlinedInput, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Stack)``;

export const SearchField = styled(OutlinedInput)`
  background: ${(p) => p.theme.palette.common.white};
  padding-left: ${(p) => p.theme.spacing(4)};
  width: 100%;
  input {
    padding: ${(p) => p.theme.spacing(1.5)};
  }
`;
